const t = "_button_1qb1u_1", u = {
  button: t,
  "button--full-width": "_button--full-width_1qb1u_21",
  "button--size-small": "_button--size-small_1qb1u_25",
  "button--size-default": "_button--size-default_1qb1u_29",
  "button--size-large": "_button--size-large_1qb1u_33"
};
export {
  t as button,
  u as default
};
//# sourceMappingURL=index.es771.js.map
